import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import AdminSidebar from "../shared/AdminSidebar";
import "./projet.css";
import qs from "qs";
import { getNodeApiBase } from "../../../utils/apiBase";

const Modification = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Make sure location.state is available and extract selectedCompetition
  const selectedCompetition = location.state?.selectedCompetition || {};
  console.log("Selected competition:", selectedCompetition);

  // Initialize form state with competition data or defaults
  const [titre, setTitre] = useState(selectedCompetition.titre || "");
  const [libelle, setLibelle] = useState(selectedCompetition.libelle || "");
  const [dateDebut, setDateDebut] = useState(
    selectedCompetition.date_debut || ""
  );
  const [dateFin, setDateFin] = useState(selectedCompetition.date_fin || "");
  const [anneeCompetition, setAnneeCompetition] = useState(
    selectedCompetition.annee_competition || ""
  );
  const [enLigne, setEnLigne] = useState(selectedCompetition.enligne || "2");

  const [budgets, setBudgets] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState(
    selectedCompetition.ID_budget_parametre || ""
  );

  const [evaluations, setEvaluations] = useState([]);
  const [selectedEvaluation, setSelectedEvaluation] = useState(
    selectedCompetition.ID_Evaluation || ""
  );
  const nodeApiBase = getNodeApiBase();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/getBudgets.php`)
      .then((response) => {
        setBudgets(response.data);
      })
      .catch((error) => {
        console.error("Error fetching budgets:", error);
      });

    // Fetch evaluation grids from Node.js API
    fetch(`${nodeApiBase}/api/evaluation/list`)
      .then((r) => r.json())
      .then((json) => setEvaluations(Array.isArray(json?.data) ? json.data : []))
      .catch((e) => console.error("Error fetching evaluations:", e));
  }, [nodeApiBase]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedBudget) {
      alert("Please select a valid budget.");
      return;
    }

    const data = {
      id_competition: selectedCompetition.idcompetition,
      titre,
      libelle,
      date_debut: dateDebut,
      date_fin: dateFin,
      annee_competition: anneeCompetition,
      enligne: enLigne,
      ID_budget_parametre: selectedBudget,
      ID_Evaluation: selectedEvaluation, // include chosen evaluation grid id
    };

    console.log("Data being sent to backend:", data);

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/UpdateCompetition.php`,
        qs.stringify(data),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        console.log("Response from backend:", response.data);
        if (response.data.message === "Competition updated successfully.") {
          alert("Competition updated successfully.");
          navigate("/admin-projet");
        } else {
          alert("Error: " + response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error updating competition:", error);
        alert("An error occurred while updating the competition.");
      });
  };

  return (
    <div className="d-flex">
      <AdminSidebar />
      <div className="main-container admin-content">
        <div className="form-card">
          <h2 className="form-title">Modifier une compétition</h2>
          <form className="form-content" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="titre" className="form-label">
                Nom de la compétition
              </label>
              <input
                type="text"
                className="form-control"
                id="titre"
                name="titre"
                placeholder="Nom de la compétition"
                value={titre}
                onChange={(e) => setTitre(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="libelle" className="form-label">
                Libellé
              </label>
              <input
                type="text"
                className="form-control"
                id="libelle"
                name="libelle"
                placeholder="Libellé"
                value={libelle}
                onChange={(e) => setLibelle(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="date_debut" className="form-label">
                Date de début
              </label>
              <input
                type="date"
                className="form-control"
                id="date_debut"
                name="date_debut"
                value={dateDebut}
                onChange={(e) => setDateDebut(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="date_fin" className="form-label">
                Date de fin
              </label>
              <input
                type="date"
                id="date_fin"
                className="form-control"
                name="date_fin"
                value={dateFin}
                onChange={(e) => setDateFin(e.target.value)}
                required
              />
            </div>
            <div className="form-group full-width">
              <label htmlFor="annee_competition" className="form-label">
                Année de la compétition
              </label>
              <input
                type="text"
                id="annee_competition"
                className="form-control"
                name="annee_competition"
                placeholder="Année (ex: 2023)"
                value={anneeCompetition}
                onChange={(e) => setAnneeCompetition(e.target.value)}
                required
              />
            </div>
            <div className="form-group full-width">
              <label className="form-label">En ligne :</label>
              <div className="radio-group">
                <label>
                  Non{" "}
                  <input
                    type="radio"
                    name="enligne"
                    value="2"
                    checked={enLigne === "2"}
                    onChange={() => setEnLigne("2")}
                  />
                </label>
                <label>
                  Oui{" "}
                  <input
                    type="radio"
                    name="enligne"
                    value="1"
                    checked={enLigne === "1"}
                    onChange={() => setEnLigne("1")}
                  />
                </label>
              </div>
            </div>
            <div className="form-group full-width">
              <label htmlFor="evaluation" className="form-label">
                Grille d'évaluation
              </label>
              <select
                id="evaluation"
                name="ID_Evaluation"
                className="form-control"
                value={selectedEvaluation}
                onChange={(e) => setSelectedEvaluation(e.target.value)}
                required
              >
                <option value="">Sélectionner une grille</option>
                {evaluations.map((ev) => (
                  <option key={ev.ID_Evaluation} value={ev.ID_Evaluation}>
                    {ev.Titre_evaluation}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group full-width">
              <label htmlFor="budget" className="form-label">
                Budget
              </label>
              <select
                id="budget"
                name="budget"
                className="form-control"
                value={selectedBudget}
                onChange={(e) => setSelectedBudget(e.target.value)} // Store the numeric ID
                required
              >
                <option value="">Sélectionner un budget</option>
                {budgets.map((budget) => (
                  <option
                    key={budget.id}
                    value={budget.id} // Set value as the numeric ID
                  >
                    {budget.appellation}
                  </option>
                ))}
              </select>
            </div>
            <button type="submit" className="submit-button">
              Enregistrer
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Modification;
